export default function navbar(commonName, target) {
    let toClear = document.getElementsByClassName(commonName);
    for (let elToClear of toClear) {
        elToClear.classList.remove("selected");
    }
    target.classList.add("selected");
}